:host {
  display: block;
}

.dynamic-entry-active-listing-error-base-font {
  font-family: var(--clrs-text-dynamic-entry);
}

.dynamic-entry-active-listing-error-icon {
  fill: var(--clrs-dynamic-entry-error-icon);
}
.dynamic-entry-active-listing-error {
  @apply flex;
  @apply text-sm;
}
.dynamic-entry-active-listing-error-link {
  @apply text-sm;
  @apply leading-10;
}
